import React from 'react';
import { timeAgo } from '@/utils/ts/stringUtils';

import AvatarComponent from '../AvatarComponent/AvatarComponent';
import ButtonComponent from '../ButtonComponent/ButtonComponent';

export default function DemographicsNotifcation({ notification, handleViewDemographics }) {
  return (
    <div className={`single-notification ${notification.seen && 'seen'}`}>
      <div className="unread-dot"></div>
      <div className="avatar-div">
        <AvatarComponent
          src={notification?.content?.profileImg}
          alt={notification?.content?.fullname || notification?.content?.username}
        />
      </div>
      <div className="text-div">
        <h3 className="title">{`Demographics for “${
          notification?.content?.fullname || '@' + notification?.content?.username
        }” are ready!`}</h3>
        <div className="btn-container">
          <ButtonComponent
            variant="text-highlight"
            style={{ padding: '0px' }}
            textStyle={{ fontSize: '14px' }}
            onClick={() => handleViewDemographics(notification?.content)}>
            View Demographics
          </ButtonComponent>
        </div>

        <p className="timestamp">{timeAgo(notification?.createdAt)}</p>
      </div>
    </div>
  );
}
